const getDataLegends = normalizedData =>
  normalizedData.map(datum =>
    datum.legend
      ? datum.legend
      : {
          color: datum.color,
          label: datum.label,
          value: datum.value,
        },
  );

export default getDataLegends;
